<template>
  <footer class="footer-area text-left">
    <div class="container-fluid">
      <div class="row">

        <div class="col-lg-3 col-md-3">
          <div class="footer-fun-text">
            <a :href="'..'+localeServicios+'/index.php'"><img src="@/assets/img/logo-tatarana-black.svg"></a>
          </div>                   
          <div class="footer-menu footer-direccion">
            <p>{{ $t('Librería online y proveedor de servicios técnicos y documentales a bibliotecas.') }}</p>
          </div> 
        </div>
        
        <div class="col-lg-3 col-md-3">
           <div class="footer-fun-text">
            <h6>Menú</h6>
          </div>
          <p>
            <a :href="'..'+localeServicios+'/index.php'">{{ $t('Inicio') }}</a><br>
            <a :href="'..'+localeServicios+'/quienes-somos.php'">{{ $t('¿Quiénes somos?') }}</a><br>
            <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'indice' } }">{{ $t('Catálogo productos') }}</router-link><br>
            <a :href="'..'+localeServicios+'/contacto.php'">{{ $t('Contacto') }}</a>
          </p>
        </div>
          
        <div class="col-lg-3 col-md-3">
           <div class="footer-fun-text">
            <h6>{{ $t('Servicios') }}</h6>
          </div>
          <p>
            <a :href="'..'+localeServicios+'/servicios-catalogacion.php'">{{ $t('Catalogación') }}</a><br>
            <a :href="'..'+localeServicios+'/servicios-procesos-tecnicos.php'">{{ $t('Procesos técnicos') }}</a>            
          </p>
        </div>  
        
        <div class="col-lg-3 col-md-3">
          <div class="footer-fun-text">
            <h6>{{ $t('Servicios') }}</h6>
          </div>
          <p>
            <a :href="'..'+localeServicios+'/servicios-indexacion.php'">{{ $t('Servicios indexación') }}</a><br>
            <a :href="'..'+localeServicios+'/servicios-informacion-seleccion.php'">{{ $t('Información y selección') }}</a>
          </p>
        </div>       

      </div>
      <div class="row">
        <div class="col-md-8 copy">
          <div class="copy-right-info">
            <p>Copyright © {{ $t('Algunos derechos reservados') }}. TATARANA, S.L. - Barcelona {{ getYear }}. Desarrollado por <a href="https://www.pohlbros.com" target="_blank" class="pohlbros">Pohlbros</a>.</p>
          </div>
        </div>
        <div class="col-md-4 copy right">
          <p><a :href="'..'+localeServicios+'/mapa-web.php'">{{ $t('Mapa web') }}</a> - <a :href="'..'+localeServicios+'/cookies.php'">Cookies</a> - <a :href="'..'+localeServicios+'/politica-privacidad.php'">{{ $t('Política de privacidad') }}</a> - <a :href="'..'+localeServicios+'/aviso-legal.php'">{{ $t('Aviso legal') }}</a></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<i18n>
{
  "es": {
    "Teléfono": "Teléfono",
    "España": "España",
    "Inicio": "Inicio",
    "¿Quiénes somos?": "¿Quiénes somos?",
    "Servicios": "Servicios",
    "Catalogación": "Catalogación",
    "Procesos técnicos": "Procesos técnicos",
    "Servicios indexación": "Servicios indexación",
    "Información y selección": "Información y selección",
    "Catálogo productos": "Catálogo productos",
    "Contacto": "Contacto",
    "Mapa web": "Mapa web",
    "Política de privacidad": "Política de privacidad",
    "Aviso legal": "Aviso legal",
    "Algunos derechos reservados": "Algunos derechos reservados",
    "Librería online y proveedor de servicios técnicos y documentales a bibliotecas.": "Librería online y proveedor de servicios técnicos y documentales a bibliotecas."
  },
  "en": {
    "Teléfono": "Phone",
    "España": "Spain",
    "Inicio": "Home",
    "¿Quiénes somos?": "About",
    "Servicios": "Services",
    "Catalogación": "Cataloging",
    "Procesos técnicos": "Technical processes",
    "Servicios indexación": "Indexing services",
    "Información y selección": "Information and selection",
    "Catálogo productos": "Product catalog",
    "Contacto": "Contact",
    "Mapa web": "Site map",
    "Política de privacidad": "Privacy Policy",
    "Aviso legal": "Legal notice",
    "Algunos derechos reservados": "Some rights reserved"
  }
  ,
  "ca": {
    "Teléfono": "Telèfon",
    "España": "Espanya",
    "Inicio": "Inici",
    "¿Quiénes somos?": "¿Qui som?",
    "Servicios": "Serveis",
    "Catalogación": "Catalogació",
    "Procesos técnicos": "Processos tècnics",
    "Servicios indexación": "Serveis d'indexació",
    "Información y selección": "Informació i selecció",
    "Catálogo productos": "Catàleg productes",
    "Contacto": "Contacte",
    "Mapa web": "Mapa web",
    "Política de privacidad": "Política de privacitat",
    "Aviso legal": "Avís legal",
    "Algunos derechos reservados": "Alguns drets reservats",
    "Librería online y proveedor de servicios técnicos y documentales a bibliotecas.": "Llibreria en línia i proveïdor de serveis tècnics i documentals a biblioteques."
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';


  export default {
    data: () => {
      return{
      }
    },
    computed: {
      ...mapGetters(['getLocale']),     
      localeServicios: function(){
        return ( (this.getLocale == 'es') ? '' : '/'+this.getLocale );
      },
      getYear: function(){
        var today = new Date();
        return today.getFullYear();
      }
    }
  }
</script>
